import { BasicDurations } from "app/services/DurationService";
import type { ValueOf } from "pro-features/types";

export const getDefaultGraphDuration = (
    duration: string,
    graphDuration: ValueOf<typeof BasicDurations>,
): ValueOf<typeof BasicDurations> => {
    if (duration === BasicDurations.LAST_TWENTY_EIGHT_DAYS && graphDuration === BasicDurations.LAST_MONTH) {
        return BasicDurations.LAST_TWENTY_EIGHT_DAYS;
    }
    if (duration !== BasicDurations.LAST_TWENTY_EIGHT_DAYS && graphDuration === BasicDurations.LAST_TWENTY_EIGHT_DAYS) {
        return BasicDurations.LAST_MONTH;
    }
    return graphDuration;
};
